import { LANG_TO_LOCALE } from '@domain/currency-preferences';

import { currencyPreferences } from './constants';

export const getLocale = (): string => {
  if (currencyPreferences.format === 'locale') {
    return LANG_TO_LOCALE[currencyPreferences.lang] ?? 'en-US';
  }
  return 'en-US';
};
